// Trainer
export const trainerProfile = 'trainer-trainee-info/trainer-profile'
export const trainerProfileListApi = trainerProfile + '/list'
export const trainerProfileStoreApi = trainerProfile + '/store'
export const trainerProfileUpdateApi = trainerProfile + '/update'
export const trainerProfileStatus = trainerProfile + '/toggle-status'

// Trainer selection trainer-id
export const trainerselection = 'trainer-trainee-info/trainer-selection'
export const trainerselectionListApi = trainerselection + '/list'
export const trainerBatchListApi = trainerselection + '/all-list'
export const getTrainerList = trainerselection + '/trainer-list'
export const trainerselectionStoreApi = trainerselection + '/store'
export const trainerselectionUpdateApi = trainerselection + '/update'
export const trainerselectionStatus = trainerselection + '/toggle-status'

export const traineeProfile = 'trainer-trainee-info/trainee-profile'
export const traineeProfileListApi = traineeProfile + '/list'
export const traineeProfileUpdateApi = traineeProfile + '/update'

// Trainer selection trainer-id
export const trainerId = 'trainer-trainee-info/trainer-id'
export const trainerListApi = trainerId + '/trainer-list'

// Trainee Evaluation apis
export const getTraineeInfoApi = 'trainer-trainee-info/trainee-evaluation/trainee-list'
export const getTraineeDetailApi = 'trainer-trainee-info/trainee-evaluation/view'
export const traineeEvaluationListApi = 'trainer-trainee-info/trainee-evaluation/list'
export const traineeEvaluationStoreApi = 'trainer-trainee-info/trainee-evaluation/store'
export const traineeEvaluationUpdateApi = 'trainer-trainee-info/trainee-evaluation/update'

// Trainer Evaluation
export const trainerDataApi = 'trainer-trainee-info/trainer-evaluation/trainer-list'
export const traineeDataApi = 'trainer-trainee-info/trainer-evaluation/trainee-list'
export const trainerEvaluationListApi = 'trainer-trainee-info/trainer-evaluation/list'
export const trainerEvaluationStoreApi = 'trainer-trainee-info/trainer-evaluation/store'

// Realase Order List
export const realaseOrder = 'trainer-trainee-info/release-order'
export const releaseOrderListApi = realaseOrder + '/list'
export const getScheduleBatchTrainee = realaseOrder + '/batch-trainee-list'
export const traineeReleaseStoreApi = realaseOrder + '/store'
export const storeCoordinateDirectorSign = realaseOrder + '/signatureUpload'

// honorarium
export const honorarium = 'trainer-trainee-info/honorarium'
export const honorariumStoreApi = honorarium + '/store'
export const honorariumUpdateApi = honorarium + '/update'
export const honorariumFileUpdateApi = honorarium + '/attachment'
export const honorariumListApi = honorarium + '/list'

// allowance
export const allowance = 'trainer-trainee-info/allowance'
export const allowanceStoreApi = allowance + '/store'
export const allowanceUpdateApi = allowance + '/update'
export const allowanceFileUpdateApi = allowance + '/attachment'
export const allowanceListApi = allowance + '/list'
export const traineeBatchListApi = allowance + '/all-list'
